export default __webpack_public_path__ + "static/media/contact-punch-light.9bc76d9c.svg";